export const SUMMARY = 'Summary';

export const AUTO = 'Auto';
export const HOME = 'Home';

export const MAKE = 'Make';
export const MODEL = 'Model';
export const YEAR = 'Year';
export const COLOR = 'Color';
export const AUTO_TYPE = 'Auto Type';
export const MILEAGE = 'Mileage';
export const DOWN_PAYMENT = 'Down Payment';
export const VEHICLE_PRICE = 'Vehicle Price';
export const TRADE_IN_VALUE = 'Trade In Value';
export const LOAN_AMOUNT = 'Loan Amount';

export const PROPERTY_TYPE = 'Property Type';
export const OCCUPANCY_TYPE = 'Occupancy';
export const HOME_PRICE = 'Home Price';

export const COMPARISON_SUMMARY_MAP = {
  [AUTO]: [
    MAKE,
    MODEL,
    YEAR,
    COLOR,
    AUTO_TYPE,
    MILEAGE,
    DOWN_PAYMENT,
    VEHICLE_PRICE,
    TRADE_IN_VALUE,
    LOAN_AMOUNT,
  ],
  [HOME]: [PROPERTY_TYPE, OCCUPANCY_TYPE, DOWN_PAYMENT, TRADE_IN_VALUE, HOME_PRICE, LOAN_AMOUNT],
};

export const SEARCH_RESULTS_FOR = 'Search Results For';

export const NO_RATES_AVAILABLE = 'No Rates Available';

export const YR = 'YR';
export const MO = 'MO';

export const FINANCE_LENDERS_HEADER_TITLE = 'Finance Lenders';

export const LOAN_TERMS = 'Loan Terms';

export const FEDERAL_CREDIT_UNION = 'Federal Credit Union';
export const FCU = 'FCU';

export const NA = 'N/A';

export const MO_PAY = 'MO Pay*';

export const LOGO_DISCLAIMER_HEADER = 'Logo Disclaimer';
export const LOGO_DISCLAIMER_TEXT =
  "The logos displayed on this platform are sourced from the respective lenders' websites. While we strive to present them accurately, please note that minor adjustments in terms of size, pixel resolution, and visual appearance may occur. These adjustments are made to ensure optimal display and do not alter the essence or identity of the logos.";

export const RATES_DISCLAIMER_HEADER = 'Rates Disclaimer';
export const RATES_DISCLAIMER_TEXT =
  "The interest rates displayed are sourced from publicly available data and are not live. Actual rates may vary based on factors such as credit score, location, lender policies, and market conditions. Please check the lender's website for the most accurate and up-to-date rates.";

export const LOGO_DISCLAIMER = {
  header: LOGO_DISCLAIMER_HEADER,
  text: LOGO_DISCLAIMER_TEXT,
};

export const RATES_DISCLAIMER = {
  header: RATES_DISCLAIMER_HEADER,
  text: RATES_DISCLAIMER_TEXT,
};

export const EMAIL_RATES = 'Email Rates';
export const EMAIL_AUTO_RATES_TO_YOURSELF = 'Email Auto Rates to Yourself';

export const CONTACT_FOR_RATES = 'Contact For Rates!';

export const lenderObjMap = {
  GPO_FCU: {
    url: 'https://www.gpofcu.com/services/tools/rates.html',
    name: 'GPO Federal Credit Union',
  },
  SUMMIT_FCU: {
    url: 'https://www.summitfcu.org/mortgage-home-equity/mortgages/',
    name: 'Summit Federal Credit Union',
  },
  BROADVIEW_FCU: {
    url: 'https://www.broadviewfcu.com/rates/?r=Loans',
    name: 'Broadview Federal Credit Union',
  },
  QUORUM_FCU: {
    url: 'https://www.quorumfcu.org/',
    name: 'Quorum Federal Credit Union',
  },
};
